import { render, staticRenderFns } from "./BalanceStatistic.vue?vue&type=template&id=09d97e9c&scoped=true"
import script from "./BalanceStatistic.vue?vue&type=script&lang=js"
export * from "./BalanceStatistic.vue?vue&type=script&lang=js"
import style0 from "./BalanceStatistic.vue?vue&type=style&index=0&id=09d97e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d97e9c",
  null
  
)

export default component.exports